import { wrapLastWord } from '../utils';

const handler = ( $ ) => {
	/**
	 * Add doodle to the last word of the title.
	 */
	const $title = $( '.hero-2-column__title' );

	if ( $title.length == 0 ) {
		return;
	}

	const titleText = $title.text();

	$title.html( wrapLastWord( titleText, 'hero-2-column__doodle' ) );
};

export default ( ( $ ) => $( handler ) )( jQuery );
